import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Lightbox from 'react-image-lightbox';
// Selectors
import { getQcImagesData } from 'store/orderDetails/OrderDetailsSelectors';

/**
 * Order level meta above the task list - delivery date, slot, order id, zone and the
 * quality check photos, which share this card rather than floating above it.
 */
const OrderMetaBar = ({ orderDetails }) => {
  const qcImages = useSelector((state) => getQcImagesData({ state }));
  const [isImgOpen, setIsImgOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState('');

  return (
    <div className="card order-task-meta order-meta-bar">
      <div className="order-task-meta-field">
        <span className="meta-value">
          {orderDetails?.deliveryDate
            ? moment(orderDetails.deliveryDate).format('DD/MM/YYYY')
            : '-'}
        </span>
        <span className="meta-label">{orderDetails?.deliveryTimeName}</span>
      </div>

      <div className="order-task-meta-field">
        <span className="meta-label">Order</span>
        <span className="meta-value">{orderDetails?.id}</span>
      </div>

      {orderDetails?.deliveryZone ? (
        <div className="order-task-meta-field">
          <span className="meta-label">Zone</span>
          <span className="meta-value">{orderDetails.deliveryZone}</span>
        </div>
      ) : null}

      {qcImages?.length > 0 ? (
        <div className="order-task-meta-field qc-meta-field">
          <span className="meta-label">Quality Check</span>
          <div className="qc-attachments">
            {qcImages.map((el) => (
              <img
                key={el}
                className="qc-img"
                src={el}
                alt="qcImg"
                onClick={() => {
                  setIsImgOpen(true);
                  setImageSrc(el);
                }}
              />
            ))}
          </div>
        </div>
      ) : null}

      {isImgOpen && <Lightbox onCloseRequest={() => setIsImgOpen(false)} mainSrc={imageSrc} />}
    </div>
  );
};

export default OrderMetaBar;
